export const SiteFooter = () => (
  <footer className="ns-sec ns-foot" data-testid="ns-footer">
    <div className="ns-wrap">
      <p className="ns-foot-wm" data-rv data-testid="ns-footer-wordmark">Norwegian AI Summit</p>
      <div className="ns-foot-grid" data-rv style={{ "--d": ".15s" }}>
        <div><span className="k">The 2027 edition</span><span className="v">The Next Shift</span><span className="v">13 April 2027 · Grieghallen, Bergen</span></div>
        <div><span className="k">Contact</span><a href="mailto:martin@norwegianaisummit.no" data-testid="ns-footer-email">martin@norwegianaisummit.no</a></div>
        <div><span className="k">Take part</span><a href="#invite" data-testid="ns-footer-invite">Request an invitation</a><a href="#partners" data-testid="ns-footer-partners">Partner with us</a></div>
        <div><span className="k">On this page</span><a href="#what">What it is</a><a href="#programme">The programme</a><a href="#bergen">Built in Bergen</a></div>
      </div>
      <div className="ns-foot-bot">
        <span>© 2026 Norwegian AI Summit</span>
        <span>Invitation-led. We reply personally.</span>
        <span>Built from Bergen, Norway</span>
      </div>
    </div>
  </footer>
);
